import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Typed from 'typed.js';

function SettingsPage() {
  const navigate = useNavigate();
  const [apiKey, setApiKey] = useState('');
  const [status, setStatus] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    const existing = localStorage.getItem('openai_api_key') || '';
    setApiKey(existing);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    const titleOptions = {
      strings: ["Welcome to Hike Mind"],
      typeSpeed: 30,
      backSpeed: 50,
      loop: false,
      showCursor: false,
      onComplete: () => {
        const subtitleOptions = {
          strings: ['To start, enter your OpenAI API key (<a href="https://platform.openai.com/api-keys" target="_blank" rel="noopener noreferrer">get one</a>)'],
          typeSpeed: 30,
          backSpeed: 50,
          loop: false,
          showCursor: false,
          contentType: 'html'
        };
        // Start subtitle typing after title completes
        new Typed('.typed-subtitle', subtitleOptions);
      }
    };
    const titleTyped = new Typed('.typed-element', titleOptions);
    return () => {
      titleTyped.destroy();
    };
  }, []);

  const handleSave = (e) => {
    e.preventDefault();
    if (!apiKey || apiKey.trim().length < 20) {
      setStatus('Please enter a valid API key.');
      return;
    }
    localStorage.setItem('openai_api_key', apiKey.trim());
    setStatus('Saved.');
    window.dispatchEvent(new Event('hikemind:api_key_changed'));
    navigate('/');
  };

  const handleClear = () => {
    localStorage.removeItem('openai_api_key');
    setApiKey('');
    setStatus('Removed.');
    window.dispatchEvent(new Event('hikemind:api_key_changed'));
  };

  return (
    <div className="landing-page">
      <div className="container">
        <h2 className="typed-element center"></h2>
        <h3 className="typed-subtitle center"></h3>
        <form onSubmit={handleSave} className="new-subject-card">
          <input
            type="password"
            ref={inputRef}
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            placeholder="sk-..."
          />
          <div className="mt-sm" style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
            <button type="submit" className="option wrapped centered">Save</button>
          </div>
          {status && (
            <p className="bottom-center-message mt-md">{status}</p>
          )}
        </form>
      </div>
    </div>
  );
}

export default SettingsPage;



